<div class="ssg-expander flex flex-fill flex-column">
  <div class="flex-row">
    <div class="flex-20px" [ngClass]="{'clickable' : expandable}" (click)="toggle()">
      <ukg-icon class="icon-position" name="paginate-right" *ngIf="expandable && !open" data-automation="caret-down">
      </ukg-icon>
      <ukg-icon class="icon-position" name="expand-more" *ngIf="expandable && open" data-automation="caret-down">
      </ukg-icon>
    </div>
    <div class="flex">
      <ng-content select="[expander-content]" data-automation="expander_content"></ng-content>
    </div>
  </div>
  <div class="no-overflow flex-row" *ngIf="open">
    <div class="flex-20px"></div>
    <div class="flex-grow">
      <ng-content select="[expanded-content]"></ng-content>
    </div>
  </div>
</div>